import { SettingsRow } from '@relay-towing/ui';
import { useNavigate } from 'react-router-dom';
import type { TabItem } from '../../lib/driverAppTabs';

/**
 * The Operations tab's items that are screens of this app, one row each,
 * opened in place. The ones run on the dashboard are the tab's one
 * dashboard button instead, so they have no rows.
 */
export function TabItemRows({ items }: { items: readonly TabItem[] }) {
  const navigate = useNavigate();
  return (
    <>
      {items.map(({ id, label, icon, opens }) =>
        'screen' in opens ? (
          <SettingsRow
            key={id}
            label={label}
            icon={icon}
            onClick={() => navigate(opens.screen)}
          />
        ) : null
      )}
    </>
  );
}
